<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
          border: 1px solid var(--el-border-color-lighter);
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          border-bottom: 0;
        "
      >
        <li
          style="
            font-size: 13px;
            font-weight: 600;
            display: flex;
            align-items: center;
          "
        >
          {{ state.model.name }}
          <el-popover placement="bottom-end" width="60%" trigger="hover">
            <template #reference>
              <el-icon
                size="20"
                color="#1e90ff"
                style="margin-left: 5px; cursor: pointer"
              >
                <View />
              </el-icon>
            </template>
            <template #default>
              <div style="font-weight: 600; font-size: 13px">基本信息</div>
              <el-descriptions
                :column="2"
                border
                style="overflow-x: auto; margin-top: 10px"
                class="desc-label-nowrap"
              >
                <el-descriptions-item label="名称" label-align="right">
                  <div style="width: 200px">
                    {{ state.model.name }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="状态" label-align="right">
                  <div style="width: 200px">
                    <text
                      :style="{
                        color: state.model.status == 0 ? '#1e90ff' : '#080',
                      }"
                    >
                      {{ state.model.status == 0 ? "操作中" : "已完成" }}
                    </text>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="所属客户" label-align="right">
                  {{ state.model.customer_name || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="客户服务类型" label-align="right">
                  {{ state.model.customer?.d_service_name || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="报税类型" label-align="right">
                  {{ state.model.d_tax_type_name || "-" }}
                </el-descriptions-item>
                <el-descriptions-item label="个税承担方式" label-align="right">
                  {{ state.model.tax_mode == 0 ? "个人" : "公司" }}
                </el-descriptions-item>
                <el-descriptions-item label="薪资所属期" label-align="right">
                  {{ $dayjs(state.model.month).format("YYYY年M月") }}
                </el-descriptions-item>
                <el-descriptions-item label="税款所属期" label-align="right">
                  {{ $dayjs(state.model.tax_month).format("YYYY年M月") }}
                </el-descriptions-item>
                <el-descriptions-item label="发放日期" label-align="right">
                  {{ state.model?.pay_date }}
                </el-descriptions-item>
                <el-descriptions-item label="客服专员" label-align="right">
                  {{
                    state.model.belonger_name +
                    "/" +
                    state.model.belonger_department_name
                  }}
                </el-descriptions-item>
                <el-descriptions-item label="创建时间" label-align="right">
                  {{ state.model.create_time }}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-popover>
        </li>
        <div
          style="
            border-radius: 7px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            flex: 1;
            padding: 0 20px;
          "
        ></div>
        <el-button
          type="success"
          size="small"
          icon="Select"
          @click="onConfirm"
          v-if="state.model.status == 0 && $judge_auth('57')"
        >
          算税完成
        </el-button>
        <el-button
          type="danger"
          link
          icon="Close"
          @click="onCancel"
          v-if="
            $judge_auth('57') &&
            (state.model.status == 0 || state.model.status == 1)
          "
        >
          取消算税
        </el-button>
      </ul>
      <div
        style="flex: 1; overflow: hidden; display: flex; flex-direction: column"
      >
        <c_CalcTaxOutsourceRecord
          v-if="state.model.id"
          :id="props.data?.id"
          :model="state.model"
          :key="state.key"
        ></c_CalcTaxOutsourceRecord>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  calctaxoutsource_detail,
  calctaxoutsource_cancel,
  calctaxoutsource_complete,
} from "@/http/calctaxoutsource";
import { confirm_func } from "@/utils/qFormat";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      model: {},
      rlzData: [],
      yrlData: [],
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      calctaxoutsource_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
        state.key = Math.random();
      });
    };

    const onCancel = () => {
      confirm_func(
        calctaxoutsource_cancel,
        props.data?.id,
        onLoad,
        "您确定要<strong style='color:#f00'>取消</strong>该算税单？"
      );
    };

    const onConfirm = () => {
      confirm_func(
        calctaxoutsource_complete,
        props.data?.id,
        onLoad,
        "您确定要<strong style='color:#080'>完成</strong>该算税单？"
      );
    };

    return { state, props, onLoad, onCancel, onConfirm };
  },
};
</script>
<style scoped lang="less">
.bankreceived-detail-rlzbox {
  box-shadow: 0 0 10px 1px #e2e2e2;
  padding: 20px 10px;
  border-radius: 7px;
  margin-top: 10px;
  display: flex;

  & > .bankreceived-detail-rlzbox-content {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    font-size: 13px;
    overflow: hidden;

    & > div {
      width: 25%;
      display: flex;
      align-items: flex-start;
      overflow: hidden;
      min-height: 30px;

      & > li:first-child {
        width: 100px;
        text-align: right;
        color: #a2a2a2;
      }
      & > li:last-child {
        flex: 1;
        word-break: break-all;
      }
    }
  }
}
</style>
